import classnames from "classnames";
import { CSSProperties } from "react";
import { SvgMapping } from "./SvgMapping";
import { IconName } from "./types";

interface Props {
  name: IconName;
  title?: string;
  width?: string;
  height?: string;
  size?: string;
  style?: CSSProperties;
  className?: string;
  strokeWhite?: boolean;
  strokeGrey?: boolean;
  strokeGreyDark?: boolean;
  strokeGreyDarker?: boolean;
  strokeBlueBright?: boolean;
  fillNone?: boolean;
  fillWhite?: boolean;
}

export const SvgInline = ({
  name,
  title,
  width,
  height,
  size,
  style,
  strokeWhite,
  strokeGrey,
  strokeGreyDark,
  strokeGreyDarker,
  strokeBlueBright,
  fillNone,
  fillWhite,
  ...props
}: Props) => {
  const className = classnames(
    props.className,
    { "svg--stroke-white": strokeWhite },
    { "svg--stroke-grey": strokeGrey },
    { "svg--stroke-grey-dark": strokeGreyDark },
    { "svg--stroke-grey-darker": strokeGreyDarker },
    { "svg--stroke-blue-bright": strokeBlueBright },
    { "svg--fill-none": fillNone },
    { "svg--fill-white": fillWhite },
  );

  const Icon = SvgMapping[name];

  return (
    <Icon
      name={name}
      className={className || undefined}
      title={title}
      style={style}
      width={width ?? size}
      height={height ?? size}
      focusable="false"
    />
  );
};
